import { PdfFieldEditor } from "../components/PdfFieldEditor";

export function AchTemplateCreatePage() {
  return <PdfFieldEditor />;
}




